import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useToggle } from "react-use";
import { obterValidador, VALIDADOR_TIPO } from "../../../../utils";
import { EntradaForm, H6 } from "../../../../components";
import { Stack } from "@mui/material";
import * as yup from "yup";
import { usersPageVariableAddEdit } from "../reducers/users-page-variable-actions";

const STR = {
  titleAddVar: "Adicionar Variável",
  titleEditVar: "Editar Variável",
  labelNameVar: "Nome da Variável",
  labelDescriptionVar: "Descrição da Variável",
  errorNameVar: "* Nome da variável deve ter ao menos 3 caracteres",
  errorDescriptionVar: "* Descrição da variável deve ter ao menos 3 caracteres",
  placeholderNameVar: "Digite o nome da variável",
  placeholderDescriptionVar: "Digite a descrição da variável",
};

const KEYS = {
  nameVar: "nome",
  descriptionVar: "descricao",
};

function VariableAddEdit({ id, name, description }) {
  const dispatch = useDispatch();
  const [wait, setWait] = useToggle();
  const schemaMessageError = {
    [KEYS.nameVar]: STR.errorNameVar,
    [KEYS.descriptionVar]: STR.errorDescriptionVar,
  };
  let schemaValidator = {
    [KEYS.nameVar]: obterValidador(VALIDADOR_TIPO.texto, 3),
    [KEYS.descriptionVar]: obterValidador(VALIDADOR_TIPO.texto, 3),
  };

  schemaValidator = yup.object().shape(schemaValidator);

  const schema = [
    {
      type: "text",
      name: KEYS.nameVar,
      label: STR.labelNameVar,
      placeholder: STR.placeholderNameVar,
      defaultValue: name,
      disabled: id ? true : false,
    },
    {
      type: "textarea",
      minRows: 3,
      multiline: true,
      name: KEYS.descriptionVar,
      label: STR.labelDescriptionVar,
      placeholder: STR.placeholderDescriptionVar,
      defaultValue: description,
    },
  ];

  const onSubmit = useCallback(
    (val) => {
      const obj = {
        [KEYS.nameVar]: val[KEYS.nameVar],
        [KEYS.descriptionVar]: val[KEYS.descriptionVar],
      };
      if (id) {
        obj.id = id;
        delete obj[KEYS.nameVar];
      }

      dispatch(usersPageVariableAddEdit(obj, setWait));
    },
    [dispatch, id, setWait]
  );

  return (
    <Stack>
      <H6>{STR.titleAddVar}</H6>

      <EntradaForm
        schema={schema}
        schemaValidator={schemaValidator}
        schemaMessageError={schemaMessageError}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
}

export default VariableAddEdit;
